var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");


var ChipLedPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(ChipLedPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
ChipLedPadGeneratorInteractionModel.$class = 'ChipLedPadGeneratorInteractionModel';

module.exports = ChipLedPadGeneratorInteractionModel;

ChipLedPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.lensType = this.shadow("lensType",
        function() {
            return self.data.lensType();
        },
        function(value) {
            return self.data.lensType(value);
        },
        [self.data.lensType]
    );

    this.colorList = [];
    this.bodyColorList = this.value("bodyColorList", true);

    this.baseHeightMin = this.shadow("baseHeightMin",
        function() {
            return self.data.baseHeightMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.baseHeightMin(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.baseHeightMin, this.userSettingsModel.distanceUnit]
    );

    this.baseHeightMax = this.shadow("baseHeightMax",
        function() {
            return self.data.baseHeightMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.baseHeightMax(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.baseHeightMax, this.userSettingsModel.distanceUnit]
    );

    this.domeDiameter = this.shadow("domeDiameter",
        function() {
            return self.data.domeDiameter() / self.getUnitFactor();
        },
        function(value) {
            return self.data.domeDiameter(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.domeDiameter, this.userSettingsModel.distanceUnit]
    );

    this.showDomeDiameterField = this.shadow("showDomeDiameterField",
        function() {
            return this.data.lensType() === cio_datamodel.IpcDataModel.ComponentAttribute.chipLedLensType["RECT_DOMED_TOP"] ;
        },
        null,
        [
            self.data.lensType
        ]
    );

     this.bodyColor = this.shadow("bodyColor",
        function() {
            return self.data.bodyColor();
        },
        function(value) {
            return self.data.bodyColor(value);
        },
        [self.data.bodyColor]
    );

     this.customBodyColor = this.shadow("customBodyColor",
        function() {
            return self.data.customBodyColor();
        },
        function(value) {
            return self.data.customBodyColor(value);
        },
        [self.data.customBodyColor]
    );

     this.showCustomBodyColorField = this.shadow("showCustomBodyColorField",
        function() {
            return !this.data.bodyColor()
        },
        null,
        [
            self.data.bodyColor
        ]
    );

    //body color list
    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.bodyColors.CHIP.LED) {
        var r  = cio_datamodel.IpcDataModel.ComponentAttribute.bodyColors.CHIP.LED[t].key;
        this.colorList.push([this.LCLZ(r, r), cio_datamodel.IpcDataModel.ComponentAttribute.bodyColors.CHIP.LED[t].value]);
    }
    this.bodyColorList(this.colorList); 

    
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForLensType = function() {
    var lensTypesList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.chipLedLensType) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.chipLedLensType[t];
        lensTypesList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('lensShape', 'Lens Shape'), this.lensType, lensTypesList)];
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit)];  
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForBaseHeight = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('A1', this.LCLZ('baseHeight', 'Base Height'), true, this.baseHeightMin, false, this.baseHeightMax, this.userSettingsModel.distanceUnit)];
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForBodyColor = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('bodyColor', 'Body Color'), this.bodyColor, this.bodyColorList)];
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForDomeDiameter = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('d' ,this.LCLZ('domeDiameter', 'Dome Diameter'), this.domeDiameter, this.userSettingsModel.distanceUnit, this.showDomeDiameterField)];
};

ChipLedPadGeneratorInteractionModel.prototype.getInspectorElementForCustomBodyColor = function() {
    return [PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('customBodyColor', 'Custom Body Color'), this.customBodyColor, this.showCustomBodyColorField, cio_config.types.string)];
};


ChipLedPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintChipLed));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('ledColorNote', '* Enter value in Hex for custom body color.')));
    imElements = imElements.concat(this.getInspectorElementForBodyColor());
    imElements = imElements.concat(this.getInspectorElementForCustomBodyColor());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForLensType());
    imElements = imElements.concat(this.getInspectorElementForDomeDiameter());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBaseHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());
    

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};